import {
  EndpointPathParameter,
  DomainEntity,
  EntityDetailSchema,
} from '@web-config-app/core';
import { mockSimpleSchema } from './mock-schemas';

const mockPathParameters: EndpointPathParameter[] = [
  {
    name: 'cactusId',
    in: 'path',
    schema: {
      type: 'string',
    },
    required: true,
  },
];

export const mockCactusEntity: DomainEntity = {
  id: 'cactuses',
  type: 'config-cactus',
  environmentSync: true,
  labelKey: 'CACTUSES',
  category: 'default',
  schema: mockSimpleSchema,
  draftingEnabled: true,
  localizable: true,
  isUsingConfigAppBackend: false,
  operations: [
    'create',
    'update',
    'publish',
    'republish',
    'clone',
    'archive',
    'unarchive',
  ],
  endpoints: {
    list: {
      path: 'v1/config-cactuses',
      method: 'GET',
    },
    create: {
      path: 'v1/config-cactuses',
      method: 'POST',
    },
    get: {
      path: 'v1/config-cactuses/{cactusId}',
      method: 'GET',
      pathParameters: mockPathParameters,
    },
    update: {
      path: 'v1/config-cactuses/{cactusId}',
      method: 'PATCH',
      pathParameters: mockPathParameters,
    },
    publish: {
      path: 'v1/config-cactuses/{cactusId}',
      method: 'PATCH',
      pathParameters: mockPathParameters,
    },
    clone: {
      path: 'v1/config-cactuses',
      method: 'POST',
    },
  },
  customOperations: {
    ping: {
      path: 'v1/config-cactuses/ping',
      method: 'GET',
      actionType: 'overflow',
      label: {
        text: 'Ping',
      },
      loadingMessage: {
        text: 'Ping-a-ling',
      },
      successMessage: {
        text: 'Pong',
      },
      parameterMappings: {
        query: [
          {
            id: 'id',
          },
        ],
        requestBody: [],
      },
    },
  },
};

export const mockOwlEntity: DomainEntity = {
  id: 'pygmy-owls',
  type: 'config-pygmy-owl',
  labelKey: 'PYGMY_OWLS',
  apiUrl: 'https://owls.com/v1/owls',
  localizable: true,
  category: 'default',
  isUsingConfigAppBackend: false,
  operations: ['create', 'update'],
  schema: {
    'x-entity-metadata': {
      entityNamePath: '$.attributes.metaData.internalName',
    },
    type: 'object',
    properties: {
      id: {
        type: 'string',
      },
      type: {
        type: 'string',
        enum: ['config-pygmy-owl'],
      },
      attributes: {
        type: 'object',
        properties: {
          entityMetadata:
            mockCactusEntity.schema.properties.attributes.properties
              .entityMetadata,
        },
      },
    },
  } as EntityDetailSchema,
  endpoints: {
    list: {
      path: 'v1/config-pygmy-owls',
      method: 'GET',
    },
    get: {
      path: 'v1/config-pygmy-owls/{pygmyOwlId}',
      method: 'GET',
      pathParameters: [
        {
          name: 'pygmyOwlId',
          in: 'path',
          schema: {
            type: 'string',
          },
          required: true,
        },
      ],
    },
    create: {
      path: 'v1/config-pygmy-owls',
      method: 'POST',
    },
    update: {
      path: 'v1/config-pygmy-owls/{pygmyOwlId}',
      method: 'PATCH',
    },
  },
};
